import { useState } from "react";

export default function FileUploadField({
  label,
  required,
  value,
  onChange,
  index,
}) {
  const [selectedFile, setSelectedFile] = useState(value || null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      onChange(index, "answer", file);
    }
  };

  const handleRemove = () => {
    setSelectedFile(null);
    onChange(index, "answer", null);
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium mb-2 text-gray-900 dark:text-white">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      <input
        type="file"
        id={`file_input_${index}`}
        onChange={handleFileChange}
        className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
      />

      {selectedFile && (
        <div className="mt-4 inline-flex items-center p-4 gap-4 bg-white border border-gray-300 rounded-lg shadow-sm text-black dark:bg-gray-800 dark:text-white dark:border-gray-600">
          <span className="truncate max-w-xs">{selectedFile.name}</span>
          <button
            type="button"
            onClick={handleRemove}
            className="ml-3 text-gray-500 hover:text-red-600"
          >
            <svg
              className="w-6 h-6 text-gray-900 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}
